import ResultItemList from './ResultItemList';

export default ResultItemList;
